export default class inputError {
    constructor (state = false, message = '') {
        this.state = false;
        this.message = '';
    }
}



// WEBPACK FOOTER //
// ./src/services/inputError.js